import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginArea.css';

export const LoginArea = ({ 
  activeTab, 
  setActiveTab, 
  username, 
  setUsername, 
  password, 
  setPassword, 
  handleLogin 
}) => {
  const navigate = useNavigate();

  return (
    <div className="login-area">
      <div className="login-area__tabs">
        <div 
          className={`login-area__tab ${activeTab === 'user' ? 'active' : ''}`}
          onClick={() => setActiveTab('user')}>
          일반 회원 로그인
        </div>
        <div 
          className={`login-area__tab ${activeTab === 'artist' ? 'active' : ''}`}
          onClick={() => setActiveTab('artist')}>
          작가 회원 로그인
        </div>
      </div>

      <div className="login-area__form">
        <div className="login-area__id-block">
          <div className="login-area__id-text">아이디</div>
          <input 
            className="login-area__id-input" 
            placeholder="6~20자 영문, 숫자" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
          />
        </div>
        <div className="login-area__pw-block">
          <div className="login-area__pw-text">비밀번호</div>
          <input 
            className="login-area__pw-input" 
            type="password" 
            placeholder="8~12자 영문, 숫자, 특수문자" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
          />
        </div>
        <div className="login-area__btn-block" onClick={handleLogin}>
          <div className="login-area__btn-text">로그인</div>
        </div>
        <div 
          className="login-area__register-btn-block" 
          onClick={() => navigate(activeTab === 'user' ? '/register' : '/artist-register')}>
          <div className="login-area__register-btn-text">회원가입</div>
        </div>
      </div>
    </div>
  );
};